
import { ICreatable } from "./ICreatable";

export class TypeBasedFactory<TSource, TInstance, TStrictSource extends TSource> implements ICreatable<TSource, TInstance> {
  constructor(private readonly is: (s: TSource) => s is TStrictSource, private readonly to: (s: TStrictSource) => TInstance) {
  }

  create(source: TSource): TInstance | null {
    return this.is(source)
      ? this.to(source)
      : null;
  }
}
